export const MAIN_PAGE_MODAL = {
    dontShowMsg: 'Не выводить'
}
